var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"policy-wrapper flow__panel"},[_c('h2',{staticClass:"policy-wrapper__title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c(_vm.policy,{tag:"component",staticClass:"policy-wrapper__policy",attrs:{"is-direct":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }